const serverIp = process.env.VUE_APP_API_BASE || 'https://contract.yajatravel.com'

export default {
  serverIp: serverIp,
}
